import React from 'react';
import './RI2020DividendText.scss';

const RI2020DividendText = ({ fund, className = '' }) => (
  <div className={`${className} r2020-dividend-text`}>
    All dividends from the {fund.name} fund will be distributed and deposited to
    your most recently added bank on file. Your bank selection can be changed
    later in your account settings. If you do not have a bank of file, dividends
    will be distributed by check to address on record.
  </div>
);

export default RI2020DividendText;
